import { styled } from "@linaria/react";
import type { FC } from "react";

const CheckboxWrapper = styled.label`
  display: flex;
  gap: 5px;
  line-height: 13px;
`;

interface CheckboxProps {
  id: string;
  state: boolean;
  onClick?: () => void;
  label?: string;
}

export const Checkbox: FC<CheckboxProps> = ({ id, state, onClick, label }) => {
  return (
    <CheckboxWrapper>
      <input
        type={"checkbox"}
        id={id}
        value={Number(state)}
        onChange={() => {
          if (onClick) {
            onClick();
          }
        }}
      />
      {label}
    </CheckboxWrapper>
  );
};
